
import Vue from 'vue';
import {
  CvButton,
  CvDropdown,
  CvDropdownItem,
  CvAccordion,
  CvAccordionItem,
} from '@carbon/vue';
import { mapActions } from 'pinia';
import TextCreation24 from '@carbon/icons-vue/es/text--creation/24';
import Save16 from '@carbon/icons-vue/es/save/16';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { useStore as useMirrorStore } from '@/stores/v2/mirror';
import { useStore as useHistoryStore } from '@/stores/v2/history';
import { createStateSnapshot } from '@/utils/historyHelperV2';
import { useStore as useNotificationStore } from '@/stores/v2/notification';
import { generateEventPayloadV2 } from '@/utils/generatePriceParamsEventPayload';

export default Vue.extend({
  name: 'TextPanelOptions',
  components: {
    CvButton,
    CvDropdown,
    CvDropdownItem,
    CvAccordion,
    CvAccordionItem,
  },
  data() {
    return {
      chevronRightSrc: require('../../../../assets/chevron--right.png'),
      chevronLeftSrc: require('../../../../assets/chevron--left.png'),
      fillLaneKey: '1',
      fillLaneItems: [
        {
          key: '1',
          value: this.$t('wizard-v2.lanyard-options.fill-lane-single'),
        },
        {
          key: '2',
          value: this.$t('wizard-v2.lanyard-options.fill-lane-tile'),
        },
      ],
      duplicateLaneKey: '1',
      duplicateLaneItems: [
        {
          key: '1',
          value: this.$t('wizard-v2.lanyard-options.duplicate-to-second-yes'),
        },
        {
          key: '2',
          value: this.$t('wizard-v2.lanyard-options.duplicate-to-second-no'),
        },
      ],
      flipLaneKey: '1',
      flipLaneItems: [
        {
          key: '1',
          value: this.$t('wizard-v2.lanyard-options.flip-the-elements-yes'),
        },
        {
          key: '2',
          value: this.$t('wizard-v2.lanyard-options.flip-the-elements-no'),
        },
      ],
      TextCreation24,
      Save16: Save16,
    };
  },
  computed: {},
  methods: {
    ...mapActions(useShapeStore, ['applyLanyardOptions']),
    ...mapActions(useHistoryStore, ['recordHistory']),
    ...mapActions(useMirrorStore, ['updateMirror', 'updateRotation']),
    ...mapActions(useNotificationStore, ['runValidators']),
    updateFlipLaneOption(flipLaneKey: string) {
      this.flipLaneKey = flipLaneKey;
    },
    updateDuplicateLaneOption(duplicateLaneKey: string) {
      this.duplicateLaneKey = duplicateLaneKey;
    },
    updateFillLaneOption(fillLaneKey: string) {
      this.fillLaneKey = fillLaneKey;
    },
    async saveSettings() {
      await this.applyLanyardOptions(this.fillLaneKey === '2');

      this.updateMirror(this.duplicateLaneKey === '1');

      this.updateRotation(this.flipLaneKey === '1');

      const eventPayload = generateEventPayloadV2();

      this.$emit('wizard:price-params-changed', {
        productPrintPositions: eventPayload,
      });

      this.runValidators();

      const snapshot = createStateSnapshot();
      this.recordHistory(snapshot);
    },
  },
});
